// @ts-nocheck

export { allowValueIfZero } from './allowValueIfZero'
export { base64ToArrayBuffer } from './base64ToArrayBuffer'
export { clientSideOrderBy } from './clientSideOrderBy'
export { clientSidePagination } from './clientSidePagination'
export { concatAddress } from './concatAddress'
export { daysSince } from './daysSince'
export { decimalToHhMm } from './decimalToHhMm'
export { download } from './download'
export { formatAddress } from './formatAddress'
export { formatCurrency } from './formatCurrency'
export { formatDate, formatDateMoment } from './formatDate'
export { formatDateTime } from './formatDateTime'
export { formatDateValue } from './formatDateValue'
export { formatDecimal } from './formatDecimal'
export { formatTime, formatTimeMoment } from './formatTime'
export { default as getCompaniesAutocompleteBase } from './getCompaniesAutocompleteBase'
export { getComparableAddress } from './getComparableAddress'
export { getComparableCompany } from './getComparableCompany'
export { getComparablePerson } from './getComparablePerson'
export { getPayPeriod } from './getPayPeriod'
export { getStatusCount } from './getStatusCount'
export { hhMmToDecimal } from './hhMmToDecimal'
export { isBlob } from './isBlob'
export { isPast } from './isPast'
export { notNullOrUndefined } from './notNullOrUndefined'
export { objectToFormData } from './objectToFormData'
export { openInNewTab } from './openInNewTab'
export { toYesNoOrUndefined } from './toYesNoOrUndefined'
export { useDebounce } from './useDebounce'
export { useDebouncedEffect } from './useDebouncedEffect'

/**
 * Returns a query string of all object key-value pairs where value is explicitly
 * **not** `null` *and* **not** `undefined` *and* **not** `''`.
 *
 * i.e. `?{key}={value}&{key2}={value2}`
 */
export const URIQuery = ({ ...parameters }): string => {
  let query = ''

  // Do not pass `null` or `undefined` values in the query parameters
  const keys = Object.keys(parameters).filter(
    key => parameters[key] !== null && parameters[key] !== undefined && parameters[key] !== '' && parameters[key] !== []
  )

  if (keys.length > 0) {
    // keys[0] is only ever used on this line to begin the query string (which must
    // start with '?') and is removed with keys.shift().
    query = '?' + keys[0] + '=' + parameters[keys.shift()!]

    keys.forEach(key => (query = query + '&' + key + '=' + parameters[key]))
  }

  return query
}
